<template>
  <div>
    <!-- task -->
    <task-list-item :item="task" type="task" @save="saveTask" @delete="removeTask" />

    <!-- comments -->
    <task-list-item
      v-for="comment in comments"
      v-if="task && comments"
      :key="comment.id"
      :item="comment"
      type="comment"
      @save="saveComment"
      @delete="removeComment"
    />

    <!-- new comment -->
    <!--<v-list-item
      avatar
      @click="focusNewComment()"
      class="task-list-tile task-list-tile-comment"
    >
      <v-list-item-avatar>
        <v-avatar size="36px" style="background-color: var(&#45;&#45;dark)">
          <span
            class="white&#45;&#45;text"
          >{{ me() }}</span>
        </v-avatar>
      </v-list-item-avatar>

      <v-list-item-content>

        <div class="task-list-tile-text-container">
          <textarea
            ref="newcomment"
            class="task-list-tile-text"
            spellcheck="false"
            placeholder="Neuer Kommentar ..."
            v-autosize="comment"
            v-model="comment"
          ></textarea>

          <div style="text-align: right; width: 100%">
            <v-btn
              depressed
              small
              @click="addComment()"
            >
              Kommentieren
            </v-btn>
          </div>
        </div>

      </v-list-item-content>
    </v-list-item>-->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  ADD_COMMENT,
  GET_TASK_FOR_GROUP,
  REMOVE_COMMENT,
  REMOVE_TASK,
  SET_TASK_ACTIVE,
  STATI,
  UPDATE_COMMENT,
  UPDATE_TASK
} from '@/config/constants';
import { TaskStatus } from '@/enums/taskstatus';
import TaskListItem from '@/components/task-components/task-list-item';
import get_avatar_initials from '@/utils/avatar-initials';
import get_id from '@/utils/id';

export default {
  components: {
    TaskListItem
  },
  props: ['task'],
  data() {
    return {
      comment: '',

      statuses: {
        [STATI.APPROVAL]: {
          name: 'Bestätigung ausstehend',
          color: 'blue',
          icon: 'done_all'
        },
        [STATI.BACKLOG]: {
          name: 'Backlog',
          color: 'pink',
          icon: ''
          //help: 'BacklogKlicke hier, um den Status auf "in Bearbeitung" zu setzen',
        },
        [STATI.IN_PROGRESS]: {
          name: 'In Bearbeitung',
          color: 'pink',
          icon: 'panorama_fish_eye'
        },
        [STATI.DONE]: {
          name: 'Fertig',
          color: 'green',
          icon: 'done'
        },
        [STATI.ARCHIVE]: {
          name: 'Archiviert',
          color: 'blue',
          icon: 'bookmark'
        },
        [STATI.SAVED]: {
          name: 'Gespeichert',
          color: 'blue',
          icon: 'save'
        }
      }
    };
  },
  mounted() {},
  computed: {
    ...mapState('users', {
      email: state => state.email
    }),
    ...mapState('slides', {
      active: state => state.active
    }),

    //

    comments() {
      return this.task.data.comments;
    },

    //

    status_keys() {
      return Object.keys(TaskStatus);
    },
    status() {
      if (this.statuses[this.task.status]) {
        return this.statuses[this.task.status];
      }
    }
  },
  methods: {
    taskActive(task) {
      this.$store.commit(SET_TASK_ACTIVE, task);
    },
    nextStatus() {
      let next = typeof this.task.status === 'number' ? this.task.status + 1 : null;
      if (this.statuses[next]) {
        this.task.status = next;
      }
    },
    addComment() {
      let comment = {
          id: get_id(),
          author: this.email,
          text: '' + this.comment
        },
        task = this.task;
      this.comment = '';
      this.$store.dispatch(ADD_COMMENT, {
        task,
        comment
      });
    },
    focusNewComment() {
      var el = this.$refs.newcomment;
      if (el && el.focus) {
        el.focus();
      }
    },
    removeTask(task) {
      this.$store.dispatch(REMOVE_TASK, task);
    },
    removeComment(comment) {
      let task = this.task;
      this.$store.dispatch(REMOVE_COMMENT, {
        task,
        comment
      });
    },
    async saveTask(task) {
      await this.$store.dispatch(UPDATE_TASK, task);
      await this.$store.dispatch(GET_TASK_FOR_GROUP, this.$store.state.slides.active._id);
    },
    saveComment(comment) {
      let task = this.task;
      this.$store.dispatch(UPDATE_COMMENT, {
        task,
        comment
      });
    },
    me() {
      return this.avatar(this.email);
    },
    avatar: get_avatar_initials
  }
};
</script>

<style lang="scss">
.task-list-tile {
  margin-top: 10px;
  margin-bottom: 20px;

  &.task-list-tile-comment {
    margin-left: 55px;
    cursor: initial;
  }

  a.v-list__tile {
    height: auto;
    cursor: initial;

    & .v-list__tile__sub-title {
      white-space: initial;
    }
    & .v-list__tile__avatar {
      align-self: flex-start;
    }
  }

  .task-list-tile-title-append {
    color: #555;
    font-size: 15px;
  }

  .task-list-tile-text-container {
    background: #f3f3f3;
    padding: 10px;
    border-radius: 5px;
    width: 100%;
  }
  .task-list-tile-comment .task-list-tile-text-container {
    background: #ececec;
  }

  button.task-list-tile-check.v-btn {
    top: 0px !important;
    right: 1px !important;
  }

  .task-list-tile-text {
    resize: none;
    outline: none;
    border: none;
    font-family: inherit;
    font-size: 14px;
    width: 100%;
  }

  .task-list-tile-buttons {
    text-align: right;
    width: 100%;
    margin-top: 5px;

    & button {
      margin-left: 5px;
    }
    & button:first-child {
      margin-left: 0px;
    }
  }
}
</style>
